module.exports = __webpack_public_path__ + "static/media/Liang Jimenez.33eb6abc.png";